
  import {defineComponent,PropType,Ref,ref} from "vue"
  import {Device} from "@/models/devices.interface";
  import {Message} from "@/models/message.interface";
  import {SMSMessage} from "@/models/message.interface";
  import DeviceComponent from "@/components/Device.component.vue";
  import {DeviceService} from "@/services/device.services";

  export default defineComponent({
   name: "ListDevices",
   components:{
      DeviceComponent
   },
   props:{
   devices:{
     type:Array as PropType<SMSMessage[]>
      }
     
    },
    setup(){

      const isActive:Ref<String> = ref("");
      const saludar=(id:string)=> {console.log(id);isActive.value=id};
      const reorder = (objetoModified)=>{};
      return {saludar,isActive,reorder};
    }
  });
